import { useState, useEffect } from 'react';

const MOBILE_WIDTH_THRESHOLD = 768;

export default function useScreenWidth() {
  const [windowWidth, setWindowWidth] = useState<number>(0);
  const [isMobileWidth, setIsMobileWidth] = useState(
    window?.innerWidth < MOBILE_WIDTH_THRESHOLD
  );

  const isWindow = typeof window !== 'undefined';

  const getWidth = (): number =>
    isWindow ? window.innerWidth : windowWidth;

  const resize = (e: any) => {
    setIsMobileWidth((prev) => {
      if (prev === e?.target?.innerWidth < MOBILE_WIDTH_THRESHOLD) {
        return prev;
      }
      return e?.target?.innerWidth < MOBILE_WIDTH_THRESHOLD;
    });

    setWindowWidth(getWidth());
  }

  useEffect(() => {
    if (isWindow) {
      setWindowWidth(getWidth());

      window.addEventListener('resize', resize);
      return () => {
        window.removeEventListener('resize', resize);
      };
    }
    //eslint-disable-next-line
  }, [isWindow]);

  return { windowWidth, isMobileWidth };
}
